import type { Locale } from "@/0-app/providers/I18nProvider";
import headsEn from "@/locales/en/heads.json";
import headsIt from "@/locales/it/heads.json";

const translations = { en: headsEn, it: headsIt } as const;

type HeadsTranslations = typeof headsEn;
type TranslationKey = keyof HeadsTranslations;

export function getHeadTranslations(locale: Locale, key: TranslationKey) {
  const t = translations[locale]?.[key];
  return {
    pageTitle: t?.pageTitle ?? "",
    description: t?.description ?? "",
    ogTitle: t?.ogTitle ?? "",
    ogDescription: t?.ogDescription ?? "",
  };
}

export function getHeadTranslation(
  locale: Locale,
  key: TranslationKey,
  metaKey: keyof HeadsTranslations[TranslationKey],
): string {
  return ((translations[locale]?.[key] as Record<string, string> | undefined)?.[metaKey]) ?? "";
}
